interface ImageFieldProps {
  url: string;
  label?: string;
}

// Display-only content — no answer to collect, so no label/error/onChange.
const ImageField = ({ url, label }: ImageFieldProps) =>
  url ? (
    <img src={url} alt={label || ''} className="max-w-full rounded-md" />
  ) : (
    <div className="flex h-32 items-center justify-center rounded-md border border-dashed border-uniform-gray-300 text-sm text-uniform-gray-400 dark:border-uniform-gray-600">
      No image URL set
    </div>
  );

export default ImageField;
